var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskMicro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#349FD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.25C17.3766 9.25 15.25 11.3766 15.25 14V18C15.25 20.6234 17.3766 22.75 20 22.75C22.6234 22.75 24.75 20.6234 24.75 18V14C24.75 11.3766 22.6234 9.25 20 9.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 18C12.75 17.5858 12.4142 17.25 12 17.25C11.5858 17.25 11.25 17.5858 11.25 18C11.25 22.5798 14.7686 26.3379 19.25 26.7183V28.953C19.0336 28.9815 18.8183 29.0223 18.6054 29.0756L17.8181 29.2724C17.4163 29.3729 17.1719 29.7801 17.2724 30.1819C17.3729 30.5837 17.7801 30.8281 18.1819 30.7276L18.9692 30.5308C19.3076 30.4462 19.6538 30.4039 20 30.4039C20.3462 30.4039 20.6924 30.4462 21.0308 30.5308L21.8181 30.7276C22.2199 30.8281 22.6271 30.5837 22.7276 30.1819C22.8281 29.7801 22.5837 29.3729 22.1819 29.2724L21.3946 29.0756C21.1817 29.0223 20.9664 28.9815 20.75 28.953V26.7183C25.2314 26.3379 28.75 22.5798 28.75 18C28.75 17.5858 28.4142 17.25 28 17.25C27.5858 17.25 27.25 17.5858 27.25 18C27.25 22.0041 24.0041 25.25 20 25.25C15.9959 25.25 12.75 22.0041 12.75 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskMicro);
export default __webpack_public_path__ + "static/media/task-micro.01d9eed94f8437c175321c9760ceafad.svg";
export { ForwardRef as ReactComponent };